import {
  GET_PAPERS,
  FILTER_PAPERS,
  SET_FILTER,
  RESET_FILTER,
  SET_COUNTRY,
  SET_DAYS,
  SET_ERROR,
} from "../actions/papers";

const initialState = {
  paperList: [],
  filter: "",
  filterList: [],
  loading: true,
  country: "Australia",
  days: 7,
  error: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PAPERS:
      return {
        ...state,
        paperList: action.paperList,
        paperListWeek: action.paperListWeek,
        loading: action.loading,
      };
    case FILTER_PAPERS:
      return {
        ...state,
        filterList: action.filterList,
        loading: action.loading,
      };
    case RESET_FILTER:
      return {
        ...state,
        filter: "",
        filterList: [],
        loading: action.loading,
      };
    case SET_FILTER:
      return {
        ...state,
        filter: action.filter,
        loading: action.loading,
      };
    case SET_COUNTRY:
      return {
        ...state,
        country: action.country,
        loading: action.loading,
      };
    case SET_DAYS:
      return {
        ...state,
        days: action.days,
        loading: action.loading,
      };
    case SET_ERROR:
      return {
        ...state,
        error: action.error,
        loading: action.loading,
        days: 7,
        country: "Australia",
        paperList: [],
        filterList: [],
      };
    default:
      return state;
  }
};

export default reducer;
